import apollo from '@/apollo.js'
import gql from 'graphql-tag'
import Vue from 'vue'

export const getMetrics = async () => {
  const response = await apollo.query({
    query: gql(`
    query getMetrics {
        currentUser {
          account {      
            caseTypes {
              metrics {
                id
                name
                type
                propertyName
                caseTypeId
                bucketId
                baseMetricId
                functionName
                createdAt
                updatedAt
                lastranAt      
                groupBy                
                intermediateStateIds    
              }
            }
          }
        }
    }
    `),
    variables: {}
  })
  return response.data
}

export const updateMetric = async (metric) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation updateMetric($id: Int!, $name: String!) {
        updateMetric(id: $id, name: $name) {
          error
          lowLevelErrorMessage
          metric {
                id
                name
                type
                propertyName
                caseTypeId
                bucketId
                baseMetricId
                functionName
                createdAt
                updatedAt
                lastranAt  
                groupBy                
                intermediateStateIds
          }
        }
      }`),
      variables: metric
    }
  )
  return response.data.updateMetric
}

export const createCasePropertyMetric = async (metric) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createCasePropertyMetric ($caseTypeId: Int!, $name: String!, $propertyName: String!) {
        createCasePropertyMetric(caseTypeId: $caseTypeId, name: $name, propertyName: $propertyName) {
          message
          error
          lowLevelErrorMessage
          metric {
            id
            name
            type
            propertyName
            caseTypeId
            bucketId
            baseMetricId
            functionName
            createdAt
            updatedAt
            lastranAt
            groupBy              
            intermediateStateIds
          }
        }
      }`),
      variables: metric
    }
  )
  return response.data.createCasePropertyMetric
}

export const createStateTransitionMetric = async (metric) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createStateTransitionMetric ($caseTypeId: Int!, $name: String!, $intermediateStateIds: [Int]!, $currentStateId: Int) {
        createStateTransitionMetric(caseTypeId: $caseTypeId, name: $name, intermediateStateIds: $intermediateStateIds, currentStateId: $currentStateId) {
          message
          error
          lowLevelErrorMessage
          metric {
            id
            name
            type
            propertyName
            caseTypeId
            bucketId
            baseMetricId
            functionName
            createdAt
            updatedAt
            lastranAt  
            groupBy            
            intermediateStateIds
          }
        }
      }`),
      variables: metric
    }
  )
  return response.data.createStateTransitionMetric
}

export const createBucketMetric = async (metric) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createBucketMetric ($caseTypeId: Int!, $name: String!, $bucketId: Int!, $baseMetricId: Int, $functionName: MetricFunctions!, $groupBy: String) {
        createBucketMetric(caseTypeId: $caseTypeId, name: $name, bucketId: $bucketId, baseMetricId: $baseMetricId, functionName: $functionName, groupBy: $groupBy) {
          message
          error
          lowLevelErrorMessage
          metric {
            id
            name
            type
            propertyName
            caseTypeId
            bucketId
            baseMetricId
            functionName
            createdAt
            updatedAt
            lastranAt  
            groupBy            
            intermediateStateIds
          }
        }
      }`),
      variables: metric
    }
  )
  return response.data.createBucketMetric
}

export const deleteMetric = async (metric) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteMetric($id: Int!) {
        deleteMetric(id: $id) {
          error
          message
          lowLevelErrorMessage
        }
      }`),
      variables: metric
    }
  )
  return response.data.deleteMetric
}

export const createWidget = async (widget) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createWidget($metricId: Int!, $type: WidgetType!, $style: WidgetStyle!, $scale: Int!, $prefix: String, $suffix: String, $timeInterval: WidgetTimeIntervals, $width: Int, $height: Int) {
        createWidget(metricId: $metricId, type: $type, style: $style, scale: $scale, prefix: $prefix, suffix: $suffix, timeInterval: $timeInterval, width: $width, height: $height) {
          error
          message
          lowLevelErrorMessage
          widget {
            id
            metricId
            metric {
              id
              name
              type
              propertyName
              caseTypeId
              bucketId
              baseMetricId
              functionName
              createdAt
              updatedAt
              lastranAt  
              groupBy              
              intermediateStateIds
              bucketMeasurements {
                measurement
                createdAt
                group
              }               
            }
            dashboardSectionId
            type
            style
            scale
            prefix
            suffix    
            timeInterval     
            width
            height   
          }
        }
      }`),
      variables: widget
    }
  )
  return response.data.createWidget
}

export const updateWidget = async (widget) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation updateWidget($id: Int!, $metricId: Int!, $type: WidgetType!, $style: WidgetStyle!, $scale: Int!, $prefix: String, $suffix: String, $timeInterval: WidgetTimeIntervals, $width: Int, $height: Int, $dashboardSectionId: Int) {
        updateWidget(id: $id, metricId: $metricId, type: $type, style: $style, scale: $scale, prefix: $prefix, suffix: $suffix, timeInterval: $timeInterval, width: $width, height: $height, dashboardSectionId: $dashboardSectionId) {
          error
          message
          lowLevelErrorMessage
          widget {
            id
            metricId
            metric {
              id
              name
              type
              propertyName
              caseTypeId
              bucketId
              baseMetricId
              functionName
              createdAt
              updatedAt
              lastranAt  
              groupBy              
              intermediateStateIds
              bucketMeasurements {
                measurement
                createdAt
                group
              }               
            }
            dashboardSectionId       
            type
            style
            scale
            prefix
            suffix            
            timeInterval
            width
            height   
          }
        }
      }`),
      variables: widget
    }
  )
  return response.data.updateWidget
}

export const reorderWidgets = async (ids) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation reorderWidgets($ids: [Int]!) {
        reorderWidgets(ids: $ids) {
          error
          message
          lowLevelErrorMessage
        }
      }`),
      variables: {ids}
    }
  )
  return response.data.reorderWidgets
}

export const deleteWidget = async (widget) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteWidget($id: Int!) {
        deleteWidget(id: $id) {
          error
          message
          lowLevelErrorMessage
        }
      }`),
      variables: widget
    }
  )
  return response.data.deleteWidget
}

export const getWidgets = async () => {
  const response = await apollo.query({
    query: gql(`
    query getMetrics {
        currentUser {
          account {      
            widgets{
              id
              metricId
              metric {
                id
                name
                type
                propertyName
                caseTypeId
                bucketId
                baseMetricId
                functionName
                createdAt
                updatedAt
                lastranAt  
                groupBy
                intermediateStateIds
                bucketMeasurements {
                  measurement
                  createdAt
                  group
                }                
              }
              dashboardSectionId
              type
              style
              scale  
              prefix
              suffix     
              timeInterval       
              width
              height
            }
            dashboardSections {
              id
              name
              widgets{
                id
                metricId
                metric {
                  id
                  name
                  type
                  propertyName
                  caseTypeId
                  bucketId
                  baseMetricId
                  functionName
                  createdAt
                  updatedAt
                  lastranAt  
                  groupBy
                  intermediateStateIds
                  bucketMeasurements {
                    measurement
                    createdAt
                    group
                  }                
                }
                dashboardSectionId
                type
                style
                scale  
                prefix
                suffix     
                timeInterval       
                width
                height
              }
            }
          }
        }
    }
    `),
    variables: {}
  })
  return response.data
}

export const createDashboardSection = async (name) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation createDashboardSection($name: String!) {
          createDashboardSection(name: $name) {
            dashboardSection {
              id
              name
            }
            error
            message
            lowLevelErrorMessage
          }
        }
      `),
      variables: { name }
    }
  )
  return response.data.createDashboardSection
}

export const updateDashboardSection = async (id, name) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation updateDashboardSection($id: Int!, $name: String!) {
          updateDashboardSection(id: $id, name: $name) {
            dashboardSection {
              id
              name
              widgets{
                id
                metricId
                metric {
                  id
                  name
                  type
                  propertyName
                  caseTypeId
                  bucketId
                  baseMetricId
                  functionName
                  createdAt
                  updatedAt
                  lastranAt  
                  groupBy
                  intermediateStateIds
                  bucketMeasurements {
                    measurement
                    createdAt
                    group
                  }                
                }
                dashboardSectionId
                type
                style
                scale  
                prefix
                suffix     
                timeInterval       
                width
                height
              }
            }
            error
            message
            lowLevelErrorMessage
          }
        }
      `),
      variables: { id, name }
    }
  )
  return response.data.updateDashboardSection
}

export const deleteDashboardSection = async (id, name) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation deleteDashboardSection($id: Int!) {
          deleteDashboardSection(id: $id) {
            error
            message
            lowLevelErrorMessage
          }
        }
      `),
      variables: { id }
    }
  )
  return response.data.deleteDashboardSection
}
